module.exports = __webpack_public_path__ + "static/4_1_supervised-learning-093ef9204766f2e678c092255425ce1b.svg";